import { useForm } from "react-hook-form";
import { useContext, useState } from "react";
import useAppNavigate from "../../components/router/use-app-navigate";
import AuthContext from "../../components/auth-context";
import Form from "../../components/inputs/form";
import Submit from "../../components/inputs/submit";
import Textbox from "../../components/inputs/textbox";
import NgnChannelApi from "../../api/ngnChannel";
import PurchaseTicketApi from "../../api/purchase-ticket";

interface NgnForm {
  channelsCount: string;
}

function PurchaseChannel() {
  const context = useContext(AuthContext);
  const { register, handleSubmit } = useForm<NgnForm>();
  const navigate = useAppNavigate();
  const [channelsCount, setChannelsCount] = useState("");
  const [error, setError] = useState<string | null>(null);

  const onSubmit: (data: any) => Promise<string> = ({ channelsCount }) => {
    return new NgnChannelApi(context)
      .post(context.activeFileId!, channelsCount)
      .then((response) => {
        if (!response.errorMessage) {
          return new PurchaseTicketApi(context)
            .post(context.activeFileId!, 11, 0)
            .then((ticket) => {
              if (ticket.errorMessage) {
                setError(ticket.errorMessage);
              } else {
                new PurchaseTicketApi(context)
                  .getAll()
                  .then(context.setTickets)
                  .catch(() => {});

                navigate(`/payment/${ticket.id}`);
              }
              return ticket.errorMessage;
            });
        }
      })
      .catch((error) => {
        console.error("NGN Channel API Error:", error);
      });
  };

  return (
    <>
      <Form submit={onSubmit} handleSubmit={handleSubmit}>
        <Textbox
          {...register("channelsCount")}
          label="تعدا کانال"
          type="number"
          onChange={(e) => setChannelsCount(e.target.value)}
          defaultValue={channelsCount}
        />
        <Submit />
      </Form>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </>
  );
}

export default PurchaseChannel;
